import {
  createReducer,
  keyValueSetReducer,
  keyValueUpdateReducer,
} from '../../redux/helpers/redux-helpers'
import { FsCore } from '../../types/fs-core'
import * as act from './elasticsearch-actions'

const elasticsearchReducer = createReducer<FsCore.ElasticSearchState>(
  {
    [act.SET_VISUAL_FILTER_BLOCK_ID]: (state, query) => ({ ...state, visualFilterQuery: query }),
    [act.SET_QUERY_RESULT]: (state, payload: act.SetQueryResultPayload) => {
      const queryState: FsCore.ESQueryState = {
        // Calculator id should be there from initial loading, might not be passed on subsequent updates
        calculatorId: payload.calculatorId || state.queries[payload.queryId]?.calculatorId,
        isLoading: false,
        isErrored: false,
        data: payload.data,
      }
      return {
        ...state,
        queries: keyValueSetReducer(state.queries, payload.queryId, queryState),
      }
    },
    [act.SET_QUERY_LOADING]: (state, { isLoading, queryId }: act.SetQueryLoadingPayload) => {
      return {
        ...state,
        queries: keyValueUpdateReducer(state.queries, queryId, { isLoading }),
      }
    },
    [act.SET_PRODUCT]: (state, product: any) => ({
      ...state,
      product,
    }),
    [act.SET_PRODUCT_DATA_SET_RESULT]: (state, payload: act.SetQueryResultPayload) => {
      const queryState: FsCore.ESQueryState = {
        calculatorId: '',
        isLoading: false,
        isErrored: false,
        data: payload.data,
      }
      const productDataSet = keyValueSetReducer(state.productDataSet, payload.queryId, queryState)
      return {
        ...state,
        productDataSet,
      }
    },
  },
  {
    queries: {},
    productDataSet: {},
  },
)

export default elasticsearchReducer
